<template>
    <carousel :perPageCustom="[[0, 1], [768, 2], [1024, 3]]">
        <slide v-for="post in socialPosts">
            <div class="col-medium-1-1 social-card__container">
                <a target="_blank" :href="post.url" class="social-card">
                    <div class="social-card__media" :style="{backgroundImage: `url(${post.thumb})`}">
                        <div class="social-card__media-overlay"
                             :style="{backgroundImage: `url(${post.overlay})`}"></div>
                        <div class="social-card__media-gradient"></div>
                    </div>
                    <div class="social-card__main">
                        <h4 class="social-card__title" v-html="post.title"></h4>
                        <div class="social-card__content" v-html="post.excerpt"></div>
                    </div>
                </a>
            </div>
        </slide>
    </carousel>
</template>

<script type="text/javascript">
    import {Carousel, Slide} from 'vue-carousel';

    export default {
        name: 'socialCarousel',
        components: {
            Carousel,
            Slide
        },
        props: [
            'socialPosts'
        ],
        mounted() {
            console.log('SOCIAL POSTS', this.socialPosts);
        }

    }
</script>



// WEBPACK FOOTER //
// SocialCarousel.vue?66076b31